import {
  AccordionButton,
  AccordionButtonProps,
  chakra,
  forwardRef,
} from '@chakra-ui/react';
import { callAllHandlers } from '@chakra-ui/utils';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type AccordionHeaderProps = OmitChakraProps<
  AccordionButtonProps,
  'as' | 'isDisabled'
>;

export const AccordionHeader = forwardRef<AccordionHeaderProps, 'header'>(
  (props, ref) => {
    return (
      <AccordionButton
        tabIndex={0}
        {...props}
        ref={ref}
        as={AsAccordionButton}
        onKeyDown={callAllHandlers(props.onKeyDown, (e) => {
          if (e.key === 'Enter') {
            e.currentTarget.click();
          }
        })}
      />
    );
  },
);

// AccordionButton thinks its a <button /> and uses props such as `type` and
// `disabled` to it. Since we are rendering the AccordionHeader as a <header />
// we want to strip these out to prevent these attributes from leaking to the
// header.
const AsAccordionButton = forwardRef<AccordionButtonProps, 'header'>(
  ({ type, disabled, ...props }, ref) => {
    return <chakra.header {...props} ref={ref} />;
  },
);
